var _style, _path, _path2, _circle, _circle2, _circle3, _circle4, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAsset36(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 335.6 58.2",
    style: {
      enableBackground: "new 0 0 335.6 58.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F4F4F4;stroke:#231F20;stroke-miterlimit:10;}\n\t.st1{fill:#1E0E17;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{fill:#231F20;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M335.6,28.6c0,0-27.8,28-62,28c-27.8,0-51.3-18.4-59.2-25.4c-1.6-1.4-1.6-3.8,0-5.2c7.9-7,31.4-25.4,59.2-25.4 C307.9,0.6,335.6,28.6,335.6,28.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121.7,26.1c1.3,1.2,1.3,3.2,0,4.3c-7.3,6.6-31.3,25.8-59.7,25.8c-34.2,0-62-28-62-28s27.8-28,62-28 C90.4,0.2,114.4,19.5,121.7,26.1z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 273.6,
    cy: 30.3,
    r: 26.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 62,
    cy: 30.2,
    r: 26.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 72.1,
    cy: 20.2,
    r: 6.9
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 284.6,
    cy: 20.2,
    r: 7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M0.7,22.2c2.1-2.6,4.5-4.9,7-7.1c2.5-2.2,5.2-4.2,8-6c2.8-1.8,5.7-3.4,8.8-4.7c3-1.4,6.3-2.3,9.5-3 c-1.6,0.6-3.2,1-4.7,1.7C28.6,3.4,27.8,3.7,27,4l-2.2,1.1C21.9,6.6,19,8.1,16.2,10c-2.8,1.8-5.4,3.7-8,5.8c-1.3,1-2.6,2.1-3.8,3.2 C3.1,20,1.9,21.1,0.7,22.2z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M333.3,22.2c-1.2-1.1-2.4-2.3-3.7-3.3c-1.2-1.1-2.5-2.1-3.8-3.2c-2.6-2-5.3-4-8-5.8c-2.7-1.8-5.6-3.4-8.6-4.9 L307,4c-0.8-0.3-1.5-0.6-2.3-0.9c-1.5-0.7-3.1-1.1-4.7-1.7c3.2,0.7,6.5,1.7,9.5,3c3.1,1.3,6,2.9,8.8,4.7c2.8,1.8,5.5,3.8,8,6 C328.8,17.3,331.2,19.7,333.3,22.2z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAsset36);
export default __webpack_public_path__ + "static/media/Asset 36.62eb717c.svg";
export { ForwardRef as ReactComponent };